import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';

// Custom IP-based language detection via edge function - always fetch without cache
const detectLanguageFromIP = async (): Promise<string> => {
  try {
    const timestamp = Date.now();
    const response = await fetch(`https://mqydajuyznbzrvwlsgld.supabase.co/functions/v1/detect-language?ts=${timestamp}`, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
      },
    });
    
    const data = await response.json();
    console.log('Language detection response:', data);
    
    return data.language || 'en-US';
  } catch (error) {
    console.error('Failed to detect language from IP:', error);
    return 'en-US'; // Default fallback
  }
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      'en-US': { translation: enUS },
    },
    fallbackLng: 'en-US',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

// Set language based on IP detection - always query API, use localStorage for quick loading only
(async () => {
  try {
    // Use previous language for quick loading (if available)
    const previousLang = localStorage.getItem('i18nextLng') || 'en-US';
    
    // Always detect current language from IP (no cache)
    const detectedLang = await detectLanguageFromIP();
    
    // If language changed, update browser storage and interface
    if (detectedLang !== previousLang) {
      console.log(`Language changed from ${previousLang} to ${detectedLang}`);
      localStorage.setItem('i18nextLng', detectedLang);
      i18n.changeLanguage(detectedLang);
    } else {
      // Same language, but make sure i18n is set correctly
      if (i18n.language !== detectedLang) {
        i18n.changeLanguage(detectedLang);
      }
    }
  } catch (error) {
    console.error('Error setting language:', error);
  }
})();

export default i18n;